import { REACT_APP_LAUNCH_SCRIPWARE_URL } from 'common/env';
import { Routes } from 'routes';
import { getOrigin } from 'utils';

export const LAUNCH_SCRIPWARE_URL = `${getOrigin()}/${REACT_APP_LAUNCH_SCRIPWARE_URL}`;
export const getPendingOrdersUrl = (isScripware: boolean) =>
    isScripware ? LAUNCH_SCRIPWARE_URL || '' : Routes.CoordinatorDashboardOrderQueue;

export const getPendingPurchaseOrderCountUrl = (isScripware: boolean) =>
    isScripware ? LAUNCH_SCRIPWARE_URL || '' : Routes.CoordinatorDashboardPOManager;
